import { STORE_DATA_REVALIDATE } from './cache';

// Timeout por intento (no el timeout global de undici, que no es configurable
// desde el fetch nativo de Node): cortamos antes para poder reintentar en vez
// de colgarnos 10s por conexion perdida. Ver plan "mejorar en dev local".
const TIMEOUT = parseInt(process.env.STORE_DATA_TIMEOUT, 10) || 8000;
const RETRIES = parseInt(process.env.STORE_DATA_RETRIES, 10) || 2;
const BACKOFF = [300, 900];

const RETRYABLE_STATUS = new Set([408, 429]);
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// fetch resiliente para datos de tienda (home/layout/producto): timeout corto
// por intento + reintentos con backoff + fallback silencioso. Nunca lanza:
// un fallo de red no debe tumbar el render, solo degradar la pagina.
export async function fetchStore(url, { label = url, fallback = null } = {}) {
  let lastError;
  for (let attempt = 0; attempt <= RETRIES; attempt += 1) {
    try {
      const res = await fetch(url, {
        signal: AbortSignal.timeout(TIMEOUT),
        next: { revalidate: STORE_DATA_REVALIDATE, tags: ['store-data'] },
      });
      if (res.ok) {
        return await res.json();
      }
      if (!RETRYABLE_STATUS.has(res.status) && res.status < 500) {
        console.warn(`fetchStore ${label}: ${res.status} ${res.statusText} (sin reintentar)`, url);
        return fallback;
      }
      lastError = new Error(`${res.status} ${res.statusText}`);
    } catch (error) {
      lastError = error;
    }
    if (attempt < RETRIES) {
      await sleep(BACKOFF[attempt] ?? BACKOFF.at(-1));
    }
  }
  console.warn(
    `fetchStore ${label}: fallo tras ${RETRIES + 1} intento(s) (${lastError?.cause?.code || lastError?.message})`,
    url,
  );
  return fallback;
}
